import React, { useEffect, useState } from "react";
import { FaFacebook, FaLinkedin, FaWhatsapp  } from 'react-icons/fa';
import FooterInterno from "../../components/Footer/FooterInterno";
import ButtonZegel from "../../components/Buttons/ButtonZegel";
import { ToastContainer, toast } from 'react-toastify';
import { windowShare
        ,FacebookPublish
        ,TwitterPublish
        ,LinkedInPublish
        ,WhatsAppPublish
        ,MessageSuccess
        ,MessageError
        ,MessageErrorPDF
        ,donwloadFile,
        FaXTemporary} from "../../helpers/helpers";
import { PrivateRoutes } from "../../routes/routes";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import LoadingGlobal from "../components/LoadingGlobal/LoadingGlobal";
import PDFViewer from "../components/PDFViewer/PDFViewer";


import "./styles/ShareCertificate.scss";
import 'react-toastify/dist/ReactToastify.css';

function ShareCertificate() {
  let {idCurso} = useParams();
  let {idPrograma} = useParams();
  let {idPersonaPrograma} = useParams();
  const navigate = useNavigate();
  const location = useLocation();

  const { res, downloading, tipo } = location.state || {}; // Desestructuración con valor por defecto
  const [urlCertificado, setUrlCertificado] = useState(null);
  const [copyLink, setLink] = useState(null);
  
  useEffect(() => {
    if (downloading === false && res?.link) {
      setUrlCertificado(res.link);
      setLink(res.link);
    }
  }, [downloading, res, tipo]);

  console.log("tipo", tipo);

  //Funciones
  // Función para abrir una ventana de compartir en Facebook
  const ShareOnFacebook = () => { window.open(FacebookPublish(res.link), '_blank', windowShare); };

  // Función para abrir una ventana de compartir en Twitter
  const ShareOnTwitter = () => { window.open(TwitterPublish(res.link), '_blank', windowShare); };
  
  // Función para abrir una ventana de compartir en LinkedIn
  const ShareOnLinkedIn = () => { window.open(LinkedInPublish(res.link), '_blank', windowShare); };
  
  // Función para abrir una ventana de compartir en WhatsApp
  const ShareOnWhatsApp = () => { window.open(WhatsAppPublish(res.link), '_blank', windowShare); };

  //Notificate about copy link
  const notifyCertificate = () => {
    if(!copyLink || copyLink.trim().length == 0) { return toast.error(MessageError,{ autoClose: 3000}); }
    navigator.clipboard.writeText(copyLink);
    toast.success(MessageSuccess,{ autoClose: 3000});
  };

  const onDocumentLoadError = () => {
    toast.error(MessageErrorPDF,{ autoClose: 3000});
  };

  return (
    <>
  {<LoadingGlobal loadingGlobal={downloading} />}

  {/*bloque de volver a la ventana anterior */}
  <div className="dashboard-progreso">
    <div className="progreso-header">
      <div className="container-center-auto">
        <button
          className="p-link-button button-img"
          onClick={() => idPrograma == null ? navigate("/"+ PrivateRoutes.HOME + "/ProgresoCurso/" + idCurso )
                                            : navigate("/" + PrivateRoutes.HOME + "/ProgresoPrograma/" + idPrograma + "/" + idPersonaPrograma + "/" + idCurso)
          }
          style={{
            fontWeight: "bold",
            color: "#000",
          }}
        >
          <i className="pi pi-arrow-left" style={{ fontSize: "1rem" }}></i>
        </button>
      </div>
    </div>
    
  {/*bloque de la vista */}
  <div className='contenedor-principal col-12 bg-gray-100 flex flex-col lg:flex-row gap-6 p-4'>
      {/*bloque del link */}
      <div className='item-div text-left col-5'  >  
        <div className="col-12">
              <h1 className='text-2xl font-semibold mb-3'>
                <strong>
                   {tipo === "Constancia"
                      ? "¡Has obtenido una constancia!"
                      : "¡Te felicitamos por tu esfuerzo!"}
                </strong>
              </h1>
              <p className='mb-5'>
                <strong>
                  {tipo === "Constancia"
                   ? "Comparte tu constancia y demuestra tu participación."
                   : "Comparte tu certificado en cualquier red social y da a conocer tus habilidades y nuevos aprendizajes adquiridos."}
                </strong>
              </p>
        </div>  
        <div className='item-link input-with-button col-12'>
            <input value={downloading ? urlCertificado : copyLink} disabled/>
            <button className="button-link" onClick={ notifyCertificate }>Copiar link</button>
            <ToastContainer
              position="top-center"
              autoClose={3000}
              closeButton={false}
              draggable={false}
              pauseOnHover={false}
              theme="dark"
              style={{ fontSize: '14px', marginTop: '1.5cm'}} 
          />
        </div>  
        <div className='item-sc-social-red mb-6 pl-0 col-12'>
            <div className='social-icons-wrapper col-4'>
              <div className='social-icon linkedin col-1'>
                <FaLinkedin aria-label="LinkedIn" onClick={ShareOnLinkedIn} target="_self" url="https://www.linkedin.com" />
              </div>
              <div className='social-icon facebook col-1'>
                <FaFacebook aria-label="facebook" onClick={ShareOnFacebook} target="_self" url="https://www.facebook.com" />
              </div>
              <div className='social-icon whatsapp col-1'>
                <FaWhatsapp aria-label="whatsapp" onClick={ShareOnWhatsApp} target="_self" url="https://www.whatsapp.com" />
              </div>
              <div className='social-icon twitter col-1'>
                <FaXTemporary aria-label="X (antes Twitter)" onClick={ShareOnTwitter} target="_self" url="https://www.twitter.com" />
              </div>
            </div>

        </div>
      </div>
     {/* bloque del certificado */}
      <div className="item-div-certificate col-6" >  
        <div className="pdf-container col-6">
        <PDFViewer pdfUrl={downloading ? urlCertificado : copyLink} onDocumentLoadError={onDocumentLoadError} />
        </div>    
        <div className='button-certifcate'>
          <ButtonZegel
            className='bg-primary-300 hover:bg-primary-500 text-white px-4 py-2 rounded'
            onClick={()=>{
              donwloadFile(res);
            }}
            >
            <strong>
               {tipo === "Constancia"
                  ? "Descargar constancia"
                  : "Descargar certificado"}
            </strong>
          </ButtonZegel>
        </div>
      </div>
    </div>
  </div>

  {/* Bloque del Footer */}
  <div className="footer-share-certificate">
    <div className="footer-content">
      <FooterInterno/>
    </div>
  </div>
  
    </>
  )
}

export default ShareCertificate